import { ReactNode } from "react";
import classNames from "classnames";
import { IoMdInformationCircleOutline } from "react-icons/io";
import TooltipWrapper from "views/uikit/TooltipWrapper";
import styles from "./style.module.scss";
import { CardVariant } from "types";
import VLPopover from "views/uikit/VLPopover";

export interface HeaderTitleProps {
  index: number;
  prefix: ReactNode;
  suffix?: { tooltipText: string; icon: ReactNode };
  debugInfo?: string;
  cardVariant: CardVariant;
  title: string | ReactNode;
}

const HeaderTitle = ({
  prefix,
  suffix,
  title,
  index,
  debugInfo,
  cardVariant,
}: HeaderTitleProps) => {
  const headerTitleClassnames = classNames(styles.headerTitle, {
    [styles.exportHeaderTitle]: cardVariant === CardVariant.SELECTED,
    [styles.similarityHeaderTitle]: cardVariant === CardVariant.VERTEX,
  });

  const renderDebugInfoIcon = () => {
    if (debugInfo) {
      const tooltipId = `debug-info-tooltip-${index}`;
      return (
        <>
          <div
            data-testid={"debug-icon"}
            data-tooltip-id={tooltipId}
            className={styles.debugInfoTooltip}
          >
            <IoMdInformationCircleOutline size={"1em"} />
          </div>
          <TooltipWrapper id={tooltipId} content={debugInfo} />
        </>
      );
    }
    return <noscript />;
  };

  return (
    <div className={headerTitleClassnames} data-testid={"title-header"}>
      <div className={styles.titleIcon}>{prefix}</div>
      <div
        className={styles.titleContainer}
        title={typeof title === "string" ? title : ""}
      >
        {title}
      </div>
      <div className={styles.debugIcon}>{renderDebugInfoIcon()}</div>
      {suffix && <CardHeaderSuffix {...suffix} />}
    </div>
  );
};

export const CardHeaderSuffix = ({
  icon,
  tooltipText,
}: {
  tooltipText: string;
  icon: ReactNode;
}) => (
  <VLPopover
    trigger={"hover"}
    content={<div className={styles.suffixTooltipContent}>{tooltipText}</div>}
  >
    <div>{icon}</div>
  </VLPopover>
);

export default HeaderTitle;
